import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AddressesPage } from '../addresses/addresses.page';
import { OrdersPage } from '../orders/orders.page';
import { ProfilePage } from '../profile/profile.page';
import { SigninPage } from '../signin/signin.page';

@Component({
  selector: 'app-tabs',
  templateUrl: 'tabs.page.html',
  styleUrls: ['tabs.page.scss']
})
export class TabsPage {

  token = '';

  constructor(public modalController:ModalController) {
    if(localStorage.getItem('token')){
      this.token = localStorage.getItem('token');
    }
  }

  async go_orders(){
    if(localStorage.getItem('token')){
      this.openModal(OrdersPage);
    } else {
      this.openModal(SigninPage);
    }
  }
  
  go_profile(){
    if(localStorage.getItem('token')){
      this.openModal(ProfilePage);
    } else {
      this.openModal(SigninPage);
    }
  }
  
  go_addresses(){
    if(localStorage.getItem('token')){
      this.openModal(AddressesPage);
    } else {
      this.openModal(SigninPage);
    }
  }


  async openModal(component){
    await(await(this.modalController.create({component:component}))).present();
  }

}
